import type { RoadmapTab } from "./nav-items"

// Requests waiting for review come first; otherwise reopen the last tab.
export function defaultRoadmapTab({
	lastPage,
	pendingCount,
}: {
	lastPage: string | null | undefined
	pendingCount: number
}): RoadmapTab {
	if (pendingCount > 0) return "pending"
	return lastPage === "hidden" || lastPage === "all" ? lastPage : "active"
}
